import { render } from "./CardEmojis.vue?vue&type=template&id=1f31749c"
import script from "./CardEmojis.vue?vue&type=script&lang=js"
export * from "./CardEmojis.vue?vue&type=script&lang=js"

import "./CardEmojis.vue?vue&type=style&index=0&id=1f31749c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__